<template>
  <div>
    <page-header
      :actions="headers.actions"
      left-side-class="col-xl-4 pb-2"
      :page="headers.page"
      right-side-class="col-xl-8 align-items-end d-flex pb-4 justify-content-end"
    />
    <div class="row my-2">
      <div class="col-12">
        <section-title has-line title="Información General" />
      </div>
      <!-- info -->
      <div class="mb-2 col-12 d-flex flex-column">
        <label class="text-muted">Nombre de Cuestionario:</label>
        <span>{{ model.questionnaireType?.name }}</span>
      </div>
      <div class="mb-2 col-3 d-flex flex-column">
        <label class="text-muted">Año Académico:</label>
        <span>{{ model.academicYear?.name }}</span>
      </div>
      <div class="mb-2 col-3 d-flex flex-column">
        <label class="text-muted">Área:</label>
        <span>{{ model.area?.name }}</span>
      </div>
      <div class="mb-2 col-3 d-flex flex-column">
        <label class="text-muted">Servicio a Ofrecer:</label>
        <span>{{ model.service?.name }}</span>
      </div>
      <div class="mb-2 col-3 d-flex flex-column">
        <label class="text-muted">Estatus:</label>
        <custom-balloon
          :background-color="model.status?.color"
          dot
          :text="model.status?.name"
        />
      </div>
      <!-- info -->
    </div>
    <div class="row my-2">
      <div class="col-12">
        <sections-config
          ref="sections"
          :input.sync="model.sections"
          :is-read-only="isReadOnly"
        />
      </div>
    </div>
  </div>
</template>

<script>
//utils
import alertMixin from '@/mixins/alert.mixin.js';

// service
import { getById, update } from '@/modules/bidQuestionConfig/api.js';

//components
import SectionTitle from 'SectionTitle';
import CustomBalloon from 'custom-balloon';
import SectionsConfig from './components/SectionsConfig.vue';
import { announcementQuestionnaireStatuses } from '@/utils/constants/announcementQuestionnaireStatus';
import { copy } from '@/utils/objUtils';

export default {
  name: 'QuestionConfigurationDetail',
  components: {
    SectionTitle,
    CustomBalloon,
    SectionsConfig,
  },
  mixins: [alertMixin],
  data() {
    return {
      model: {
        id: null,
        academicYear: null,
        questionnaireType: null,
        service: null,
        status: null,
        area: null,
        sections: [],
      },
    };
  },
  computed: {
    isReadOnly() {
      return this.isSubmitted;
    },
    id() {
      return Number(this.$route.params.id);
    },
    isSubmitted() {
      return (
        this.model?.status?.id === announcementQuestionnaireStatuses.Submitted
      );
    },
    isDraft() {
      return this.model?.status?.id === announcementQuestionnaireStatuses.Draft;
    },
    headers() {
      return {
        page: {
          title: 'Configuración Preguntas para Pliegos',
          icon: 'fas fa-building',
          routes: [
            'Proceso de Competencias',
            'Configuración Preguntas para Pliegos',
          ],
        },
        actions: [
          {
            text: 'Regresar',
            icon: 'far fa-arrow-circle-left',
            variant: 'outline-success',
            click: () => this.$router.push({ name: 'questionConfiguration' }),
          },
          {
            text: 'Guardar',
            icon: 'fas fa-save',
            variant: 'outline-success',
            visible: this.isDraft,
            click: () => this.save(),
          },
          {
            text: 'Someter',
            icon: 'fas fa-flag-alt',
            variant: 'success',
            visible: !this.isSubmitted,
            click: () => this.submit(),
          },
        ],
      };
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    getEmptyModel() {
      return {
        id: null,
        academicYear: null,
        questionnaireType: null,
        service: null,
        status: null,
        area: null,
        sections: [],
      };
    },
    async init() {
      const model = this.id
        ? await this.getInfo(this.id)
        : this.getEmptyModel();
      this.model = copy(model);
    },
    async getInfo() {
      const { data } = await getById(this.id);
      data.sections.forEach((x) => {
        x.valid = true;
        x.expanded = false;
        //localidad
        if (x.id == 130) {
          x.questions = [
            {
              name: null,
              typeId: 0,
              answers: [],
              childQuestions: [],
              valid: true,
              expanded: false,
              location: {
                quantity: x.questions.length / 6, //Corresponde a 6 preguntas por localidad
                state: null,
                municipality: null,
                addressLine1: null,
                addressLine2: null,
                postalCode: null,
                attachment: null,
              },
            },
          ];
        }
        x.questions.forEach((q) => {
          q.valid = true;
          q.expanded = false;
        });
      });
      return data;
    },
    async save(submitted = false) {
      if (this.model.sections.length === 0) {
        this.ShowToast(
          'Error',
          'Es necesario seleccionar al menos una sección para guardar.',
          'error'
        );
        return;
      }
      const valid = await this.validate();

      if (!valid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      if (submitted) {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea someter esta configuración?',
          'Si',
          'No'
        );

        if (!confirmed) return;
      }
      const payload = {
        submitted,
        sections: this.model.sections,
      };

      try {
        await update(this.model.id, payload);
      } catch (error) {
        this.ShowToast('Error', error.response.data.message, 'error');
        return;
      }

      this.ShowToast(
        'Proceso exitoso',
        'Los cambios fueron guardados exitosamente',
        'success'
      );

      if (submitted) {
        this.$router.push({
          name: 'questionConfigurationPreview',
          params: { i: this.model.id },
        });
        return;
      }

      await this.getInfo();
    },
    async submit() {
      await this.save(true);
    },
    async validate() {
      const validS = await this.$refs['sections'].validate();
      return [validS].every((x) => x);
    },
    async preview() {},
  },
};
</script>
<style scoped></style>
